<template>
  <b-card class="m-3" id="lista-multimidia-header-Card" header-tag="header" no-body v-if="lista && lista.length">
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="font-weight-bold">Multimídia</span>
      </h6>
    </template>
    <b-card-text>
      <b-table :fields="fieldsMultimidia" hover no-border-collapse :items="lista" show-empty striped>
        <template #empty="">Não há informações disponíveis.</template>
        <template v-slot:cell(DataInclusao)="row">
          {{ formatData(row.item.DataInclusao) }}
        </template>
        <template v-slot:cell(NomeArquivo)="row">
          <a href="#" @click.prevent="baixarMultimidia(row.item)">{{
              row.item.NomeArquivo
          }}</a>
        </template>
      </b-table>
    </b-card-text>
  </b-card>
</template>

<script>
import { UtilsTS } from '@/utilsts';
import { baixarArquivoMultimidia, montarNomeArquivoMultimidia } from "@/utils/peca-unica";

export default {
  name: "ListaMultimidia",
  mixins: [UtilsTS],
  props: {
    lista: {
      type: Array,
      default(_r) {
        return [];
      },
    },
  },
  data() {
    return {
      fieldsMultimidia: [
        {
          key: "DataInclusao",
          label: "Data de Inclusão",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "NomeArquivo",
          label: "Nome",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Descricao",
          label: "Descrição",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    async baixarMultimidia(arquivo) {
      try {
        const blob = await baixarArquivoMultimidia(String(arquivo.CodCriptografado));
        const nomeArquivo = montarNomeArquivoMultimidia(
          arquivo?.NomeArquivo,
          arquivo?.CodCriptografado
        );
        this.download(nomeArquivo, blob);
      } catch (error) {
        this.tratarError(error);
      }
    },
  },
};
</script>

<style>
</style>
